// extracted by mini-css-extract-plugin
export default {"heading":"iB-z","corrected":"jB-z","redirectVerbiageContainer":"kB-z","redirectVerbiageText":"lB-z"};